
import { Button } from "@/components/ui/button";
import { ButtonColorful } from "@/components/ui/button-colorful";

interface FormActionsProps {
  isSubmitting: boolean;
  onCancel: () => void;
  submitLabel?: string;
}

export function FormActions({ isSubmitting, onCancel, submitLabel = "Add Client" }: FormActionsProps) {
  return (
    <div className="flex gap-4 justify-end pt-6">
      <Button
        type="button"
        variant="outline"
        onClick={onCancel}
      >
        Cancel
      </Button>
      <ButtonColorful
        type="submit"
        label={submitLabel}
        isLoading={isSubmitting}
        disabled={isSubmitting}
        className="shadow-lg"
      />
    </div>
  );
}
